/** Returns cleanup for the exact listener registered by this component. */
export function watchPageVisibility(listener: () => void): () => void {
    document.addEventListener('visibilitychange', listener);
    return () => document.removeEventListener('visibilitychange', listener);
}
